import {
    Component, OnInit, ElementRef, forwardRef, Input, OnChanges, Output, EventEmitter,
    Renderer2, OnDestroy, Self, Query, QueryList, Directive, Provider, ViewEncapsulation, NgModule, SimpleChanges
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CodeTypeValue, CodeTypeRequest } from './codetypevalue.interface';
import { CodeTypeValueService } from './codetypevalue.service';
import { Router } from '@angular/router';

import {
    NG_VALUE_ACCESSOR
    , ControlValueAccessor
    , SelectControlValueAccessor
} from '@angular/forms';
import { ApiResponseModel } from '../../models/api_response_model';
import { AppData } from '../../models/appdata';
import { SpinnerService } from '../../services/spinner.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbEditCodetypeValueModal } from './modal/editcodetypevalue.modal';
//import ErrorHandlerService from '../../shared/globalerrorhandler';


import { CommonModule } from '@angular/common';

const noop = () => {
};


@Component({

    selector: 'CodeTypeValue',

    templateUrl: './codetypevalue.component.html',
    providers: [CodeTypeValueService,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CodeTypeValueComponent),
            multi: true
        }

    ],
})
export class CodeTypeValueComponent implements OnInit, OnChanges
    , ControlValueAccessor
{
    ngOnChanges(changes: SimpleChanges) {
        let shouldRefresh = false;
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                const change = changes[propName];
                if (!change.firstChange && change.currentValue !== change.previousValue) {
                    shouldRefresh = true;
                }
            }
        }
        if (shouldRefresh) {
            this.refreshAndLoadData();
        }
    }

    refreshAndLoadData() {
        this.CurrentCodeTypeRequest = new CodeTypeRequest();
        this.CurrentCodeTypeRequest.CodeType = this.CodeType;
        this.CurrentCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms || { xUserName: 'admin', xAuthGenKEY: '' } as any;
        this.GetCodeValuesByType(this.CurrentCodeTypeRequest);
    }
   
    //http://almerosteyn.com/2016/04/linkup-custom-control-to-ngcontrol-ngmodel
   
    private innerValue: any = '';
    public isRequesting: boolean = false;
   
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

  public key: string;

  @Input()
  get Key() {
    return this.key;
  }

  @Output() keyChange = new EventEmitter();
  set Key(value: string) {
    this.key = value;
     // alert('emitting...' + this.Key);       
    this.keyChange.emit(this.Key);
  }

    
    get value(): any {
        return this.innerValue;
    };

   
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }



    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }


    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

  
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
  
    onChange(Event: any) {
      //alert("hi-->" + Event);

      if (Event != null) {

        var a = this.ddlRefferedType.filter(x => x.LongValue === Event || x.ShortValue === Event)
        if (a.length > 0) {
          this.Key = a[0].LongValue;
         // alert("hi-->" + this.Key);
          //console.log('this.Key-->' + this.Key + ' a[0].Code->' + a[0].DisplayName);

        }
        else {
          this.key = "";
        }
      }

        this.innerValue = Event;
        this.onTouchedCallback();
        this.onChangeCallback(this.innerValue);
        console.log(this.innerValue);
    }

    //***********************************/
    @Input() CodeType: string;
    @Input() SelectedValue: string = "";
    @Input() PassType: string = "Short";

    public ApiResData: ApiResponseModel;

    CurrentCodeTypeRequest: CodeTypeRequest;

    constructor(
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
        public _router: Router, private loaderService: SpinnerService, public codeTypeValueService: CodeTypeValueService,
        private modalService: NgbModal
       //, public ErrorHandlerService: ErrorHandlerService
    ) {


    }

    ddlRefferedType: CodeTypeValue[];



    ngOnInit() {
      this.CurrentCodeTypeRequest = new CodeTypeRequest();
      this.CurrentCodeTypeRequest.CodeType = this.CodeType;
      this.CurrentCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms || { xUserName: 'admin', xAuthGenKEY: '' } as any;

      this.GetCodeValuesByType(this.CurrentCodeTypeRequest);
    }

    sortNull() { return 0;}
    GetCodeValuesByType(SendCodeTypeRequest: CodeTypeRequest): void {
        this.StartRefreshing();

        this.codeTypeValueService.GetCodeValuesByType(SendCodeTypeRequest).subscribe
          (
          (result) => {
            this.ApiResData = result;
            if (!this.ApiResData.hasError) {
                const rawResult = this.ApiResData.Result || (this.ApiResData as any).result || [];
                this.ddlRefferedType = rawResult;
                if (this.PassType == 'Long') {
                    var a = (this.ddlRefferedType || []).filter(x => (x.LongValue || (x as any).longValue) == this.SelectedValue)
                    if (a.length > 0) {
                        const shortVal = a[0].ShortValue || (a[0] as any).shortValue;
                        this.SelectedValue = shortVal;
                        this.value = shortVal;
                    }
                }
              this.stopRefreshing();
            }
            else {
              this.stopRefreshing();
              if (this.ApiResData.ErrorData != "") {

                alert(this.ApiResData.ErrorData);
              }
              else {
                alert(' Failed Due to Internal Error.... Please Contact Admin..');
              }
            }

          },
            //(ddlRefferedType) => {
            //    this.ddlRefferedType = ddlRefferedType;
            //    this.stopRefreshing();
            


            //},

          (error) => {

            if (error == "401 - Unauthorized") {
             // alert(error);
              this.stopRefreshing();



            }
            else {
             // alert(error);
              this.stopRefreshing();
            }
          }
            );;

  }
  EditCodeType() {
    const modalRef = this.modalService.open(NgbEditCodetypeValueModal,
      {
        centered: true

      })
    modalRef.componentInstance.CodeType = this.CodeType;
    //modalRef.componentInstance.CycleCode = this.CycleCode;
    modalRef.result.then(x => { this.GetCodeValuesByType(this.CurrentCodeTypeRequest) })
  }
    private stopRefreshing() {
      this.loaderService.displayLoader(false);
        this.isRequesting = false;
        //alert(this.isRequesting);
    }
    private StartRefreshing() {
      this.loaderService.displayLoader(true);
        this.isRequesting = true;
        //alert(this.isRequesting);
    }

}
